export enum PageState {
  CreateView = 'create',
  EditView = 'edit',
  ReadOnlyView = 'read-only',
  NoAccessView = 'no-access',
}
